import { NextFetch } from '@/utils/request';
import host from '@/utils/request/host';

interface CarSpecsResult {
  specList?: SpecDetail[];
  /** 车型图片 */
  wareThumbnail?: string;
  minPrice?: number;
  maxPrice?: number;
  seriesName?: string;
}

export interface SpecDetail {
  /** 车型id */
  id?: number;
  selected?: boolean;
  /** 车系名称 */
  specName?: string;
  /** 车辆sku列表 */
  carSkuList?: SpecSkuDetail[];
  /** 车型图片，待扩展项 */
  thumbnail?: string;
  specThumbnail?: string;
}

export interface SpecSkuDetail {
  /** 车辆名称 */
  carName: string;
  /** 颜色名称 */
  exteriorColor: string;
  materialCode: string;
  /** 销售价格 */
  salesPrice: number;
  productId: number;
  selected?: boolean;
  /** 车型规格图片，待扩展项 */
  thumbnail?: string;
  appearImg?: string;
}

export interface InteriorColor {
  id?: number;
  brandName?: string; //品牌名称
  dealerId?: number; //商家id
  shopId?: number; //门店id
  shopName?: string; //门店名称
  brandId?: number; //品牌id
  seriesId?: number; //车系id
  seriesName?: string; //车系名称
  specId?: number; //车型id
  specName?: string; //车型名称
  specCode?: string; //车型代码
  interiorColor?: string; //内饰颜色
  interiorImg?: string; //内饰图片
  appearColor?: string; //外观颜色
  appearImg?: string; //外观图片
  materialCode?: string; //物料代码
  materialName?: string; //物料名称
  status?: number; //状态 1已上架2已下架
  dealerRetailPrice?: number; //商家零售价格
  factoryRetailPrice?: number; //厂家零售指导价格
  putawayApplyId?: number; //上架审批id
  soldOutApplyId?: number; //下架审批id
  approveStatus?: number; //审批状态 1审批中2已通过3已拒绝
  approveTime?: number; //审批时间
  createBy?: number;
  updateBy?: null;
  selected?: boolean;
  thumbnail?: string; //车系缩
  unique?: boolean; // 是否物料代码唯一
  uniqueCode?: string; // 区分code
}

export interface SkuInfo {
  seriesName?: string;
  specName?: string;
  specId?: number;
  exteriorColor?: string;
  exteriorColorId?: number;
  interiorColor?: string;
  interiorColorId?: number;
  price?: number | string;
  specImg?: string;
  carImg?: string;
  carName?: string;
}


export async function getDetailApi(params?: any) {
  return await NextFetch.get<CarSpecsResult>(`${host.fvm}/select/shop/series/spec`, params);
}

export async function getMaterialApi(params?: any) {
  return await NextFetch.get<InteriorColor[]>(`${host.fvm}/select/shop/spec/material`, params);
}
